var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('wac-background',{staticClass:"wac-header-meta",attrs:{"variant":"light"}},[_c('wac-layout',[_vm._t("meta")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }